import { PERMISSIONS_SUBJECT_ENUM } from 'redux-store/api/company-roles';
import { TItem } from './types';

export const ITEMS: TItem[] = [
  {
    id: 1,
    name: 'schedule',
    path: '/project-dashboard',
  },
  {
    id: 5,
    name: 'my tasks',
    path: '/my-tasks',
  },
  {
    id: 2,
    name: 'selections',
    path: '/selections',
    permissionSubject: PERMISSIONS_SUBJECT_ENUM.SELECTION_MANAGE,
    permissionScope: 'canRead',
  },
  {
    id: 3,
    name: 'file Cabinet',
    action: true,
    permissionSubject: PERMISSIONS_SUBJECT_ENUM.VIEW_PROJECT_FOLDERS,
    permissionScope: 'canRead',
  },
  {
    id: 4,
    name: 'media',
    path: '/media',
    permissionSubject: PERMISSIONS_SUBJECT_ENUM.MEDIA,
    permissionScope: 'canRead',
  },
];
